
import { useState, useEffect, useMemo } from 'react'; // Added useMemo
import { useParams } from 'react-router-dom';
import { Portfolio } from '@/schemas/portfolio'; // Changed to Zod-inferred type
import { useFirebase } from '@/context/FirebaseProvider'; // Replaced useDataUtils

export const usePortfolioState = () => {
  const { portfolioId } = useParams<{ portfolioId: string }>(); // Added type for params
  const { portfolios } = useFirebase(); // Get portfolios from FirebaseProvider
  
  // Get portfolio from context/global state
  const portfolio = useMemo(() => {
    if (!portfolioId || !portfolios) return null;
    return portfolios.find(p => p.id === portfolioId) || null;
  }, [portfolioId, portfolios]);
  
  // Create state for form management
  const [name, setName] = useState('');
  const [initialName, setInitialName] = useState('');
  const [formEdited, setFormEdited] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  
  // Track when name changes
  useEffect(() => {
    setFormEdited(name !== initialName);
  }, [name, initialName]);

  // Reset initialLoadComplete when portfolioId changes
  useEffect(() => {
    if (portfolioId) {
      setInitialLoadComplete(false);
    }
  }, [portfolioId]);

  // Update name when portfolio data loads or changes
  useEffect(() => {
    if (portfolioId && !initialLoadComplete && portfolio) {
      const portfolioName = portfolio.name || '';
      console.log("Loading portfolio name from Firebase:", portfolioName);
      
      setName(portfolioName);
      setInitialName(portfolioName);
      setInitialLoadComplete(true);
    }
  }, [portfolioId, portfolio, initialLoadComplete]);
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setName(value);
  };

  return {
    portfolioId,
    portfolio,
    name,
    initialName,
    formEdited,
    handleInputChange,
    setName,
    setInitialName,
    setFormEdited
  };
};
